
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import {
setTimeout
} from 'timers';
import NProgress from 'nprogress'
import {
mapState,
mapMutations,
mapActions
} from 'vuex'
import ProCard from '../../components/card/ProCard.vue'
import CardMb from '../../components/card/CardMb'
import PopCart from '../../components/cart/PopCart.vue'
import Search from '../../components/search/Search'
import {
goodProduct,
getProductPic,
campaignGoods,
getGoodsByType,
searchGoods,
campaignRule,
userInfo,
landingPage
} from '../../service/index'
import {
productCombine
} from '../../utils/storage'
import skeleton from '../../main.skeleton'

export default {
name: 'Home',
data() {
return {
campaignType: 1,
pageSize:12,
total: 0,
isShow: false,
productDetail: {},
spec: {},
productPic: {},
products: {},
showMoveDot: [],
filter: {},
type: 0,
cat: 0,
searchDefault: '搜索',
homeBread: ['内购', '全部'],
cid: '',
showAllGoods: [],
loading: false,
keyword: '',
isLoading: true,
rule: {},
profileHead: require('../../assets/default-avatar.png'),
profileHeadMb: require('../../assets/default-avatar.png'),
splashLoading: true,
showCat:false,
viewType: 2,
orderPrice: 0,
userInfo: {},
ladingPages: []
}
},
mounted() {
this.getUserInfo()
this.initHome()
if(!this.global.isPc){
this.$nextTick(function () {
window.addEventListener('scroll', this.onScroll)
})
}
},

activated() {

},






components: {
ProCard,
Search,
CardMb,
PopCart,
Grid,
GridItem,
GroupTitle,
skeleton
},
computed: {
...mapState([
'global', 'categories', 'campaign', 'searchKey', 'currentPage', 'goods', 'user'
]),
showGoods: {
get() {
if (this.goods) {
return this.goods.slice && this.goods.slice((this.currentPage - 1) * this.pageSize, this.currentPage *
this.pageSize);
}
return []
},
set() {

}
},
showMobileGoods: {
get() {
if (this.goods) {
return this.goods.slice && this.goods.slice(0, this.currentPage *
this.pageSize);
}
return []
},
set() {}
},

firstCol() {
var output = []
for (var i = 0; i < this.showMobileGoods.length; i++) {
if (i % 2 == 0) {
output.push(this.showMobileGoods[i]);
}
}
return output;






},
secondCol() {






var output = []
for (var i = 0; i < this.showMobileGoods.length; i++) {
if (i % 2 != 0) {
output.push(this.showMobileGoods[i]);
}
}
return output;
},
bread() {
let locale = localStorage.locale;
const self = this;
const zhBread = locale === 'zh' ? [{
name: '首页'
}] : [{
name: 'Home'
}]
if (self.searchKey) {
return [`"${self.searchKey}"搜索结果`]
}
if (self.type) {
self.categories && self.categories.map(item => {
if (item.id === self.type) {
zhBread.push(item)
}
})
}
if (self.cat) {
self.categories && self.categories.map(item => {
if (item.id === self.type) {
item.children.map(cat => {
if (cat.id === self.cat) {
zhBread.push(cat)
}
})
}
})
}
return zhBread;
},
searchKeyword() {
const self = this;
const result = [];
if (self.keyword) {
return self.keyword
}
if (self.cat) {
self.categories && self.categories.map(item => {
if (item.id === self.type) {
item.children.map(cat => {
if (cat.id === self.cat) {
result.push(cat.name)
}
})
}
})
}
if (self.type) {
self.categories && self.categories.map(item => {
if (item.id === self.type) {
result.push(item.name)
}
})
}
return result.length > 0 ? result[0] : ''
},
},
watch: {
currentPage: function (val, oldVal) {
this.showGoods = this.showAllGoods.slice && this.showAllGoods.slice((val - 1) * this.pageSize, val * this.pageSize);
},

$route(to) {
this.orderPrice = 0
this.initHome()
},
},
methods: {
...mapMutations({
initGoods: 'INIT_GOODS',
changePage: 'CHANGE_PAGE',
recordUserinfo: 'RECORD_USERINFO',
changeOrderPirce: 'ORDER_PRICE'
}),
...mapActions(['showRule']),
async getLandingPage() {
const pages = await landingPage(this.cid)
this.ladingPages = pages.data
if(this.ladingPages == null || this.ladingPages.length == 0) {
this.showCat = false
}else{
this.showCat = this.$route.query.cat || this.$route.query.type ? false : true;
}

if(this.showCat) {
this.changeCurrentPage(1)
}
},
async getCampaignGoods() {
const allGoods = await campaignGoods(this.cid)
this.isLoading = false
if (allGoods.status === 0) {
this.initGoods(allGoods.data)
this.campaignType = allGoods.data[0].campaignType;
this.showAllGoods = allGoods.data
this.changeOrderPirce(this.orderPrice)
}
},
orderByPrice(type) {
if(this.orderPrice == type) {
this.orderPrice = 0
this.initHome()
}else{
this.orderPrice = type
this.changeOrderPirce(type)
}
},
changeView(type) {

this.viewType = type
},
getRuleInfo() {
this.showRule(this.$route.query.cid)
},
getScrollTop() {
var scrollTop = 0
if (document.documentElement && document.documentElement.scrollTop) {
scrollTop = document.documentElement.scrollTop
} else if (document.body) {
scrollTop = document.body.scrollTop
}
return scrollTop
},

getClientHeight() {
var clientHeight = 0
if (document.body.clientHeight && document.documentElement.clientHeight) {
clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
} else {
clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
}
return clientHeight
},


getScrollHeight() {
return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
},
onScroll() {
if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 100) {
let _page=this.currentPage
_page += 1
this.changePage(_page)
}
},
async getUserInfo() {
const res = await userInfo(this.$route.query.cid)
if (res.status === 0) {
this.userInfo = res.data
console.log("this.userInfo", this.userInfo)
this.recordUserinfo(res.data)
}
},
async getGoodsOfType(typeId) {
const res = await getGoodsByType(typeId)
this.isLoading = false
if (res.status === 0) {
this.initGoods(res.data)
this.showAllGoods = res.data
this.changeOrderPirce(this.orderPrice)
}
NProgress.done()
},
async getGoodsOfCat(typeId, catId) {
const res = await getGoodsByType(typeId)
this.isLoading = false
if (res.status === 0) {
const typeGoods = res.data.filter(item => item.productTypeId === typeId)
this.showAllGoods = typeGoods.filter(item => item.productCategoryId === catId);
this.initGoods(this.showAllGoods)
this.changeOrderPirce(this.orderPrice)
}
NProgress.done()
},
async doSearch() {
const res = await searchGoods(this.$route.query.cid, {
keyword: this.keyword
})
this.isLoading = false
if (res.status === 0) {

this.showAllGoods = res.data;
}
},
async doPcSearch() {
const res = await searchGoods(this.$route.query.cid, {
keyword: this.searchKey
});
this.isLoading = false
if (res.status === 0) {
this.initGoods(res.data)
this.showAllGoods = res.data;
}
},
clearQuery() {
this.keyword = ''
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {
cid: this.$route.query.cid
}
})
},
changeCurrentPage(val) {
this.changePage(val)
},
async changeVisible(goodInfo) {
const loading = this.$loading({
lock: true,
text: '',
spinner: 'el-icon-loading',
background: 'rgba(0, 0, 0, 0.7)',
customClass: 'fullscree-loading'
});
const goodDetail = await goodProduct(goodInfo.id);
this.spec = productCombine(goodDetail.data);
this.products = goodDetail.data;
this.productDetail = goodInfo
const productPicture = await getProductPic(goodInfo.id)
this.productPic = productPicture.data;
this.isShow = true
const res = await await campaignRule(this.$route.query.cid);
if (res.status === 0) {
this.rule = res.data
}
loading.close();
},
closePop() {
this.isShow = false
},
goToMenuMb() {
if (this.global.currentActivityEnd === -13) return false
this.$router.push({
name: 'cat',
query: {
cid: this.$route.query.cid
}
})
},
goHomeWithFilter(typeId, catId) {

NProgress.start()


if (catId) {
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {
type: typeId,
cat: catId,
cid: this.$route.query.cid
}
})
} else {
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {
type: typeId,
cid: this.$route.query.cid
}
})
}



},
goHome() {
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {
cid: this.$route.query.cid
}
})
},
goToDetails(id) {
this.$router.push({
name: 'detailMb',
query: {
id,
cid: this.$route.query.cid
}
});
},
goToSearch(keyword) {


if (this.global.currentActivityEnd === -13) return false
keyword = keyword || ''
this.$router.push({
path: '/search',
query: {
cid: this.$route.query.cid,
keyword
}
})
},
keepLang() {
let locale = localStorage.locale;
this.$i18n.locale = locale === 'en' ? locale : 'zh';
},
initHome() {
console.log('init home')
const self = this;
this.isLoading = true
if (this.$route.name === 'home') {
this.keepLang()

this.type = parseInt(this.$route.query.type || 0)
this.cat = parseInt(this.$route.query.cat || 0)
this.keyword = this.$route.query.keyword || ''
this.cid = this.$route.query.cid;
this.getLandingPage();

if (this.type && this.cat) {
this.getGoodsOfCat(this.type, this.cat)
} else if (this.type) {
this.getGoodsOfType(this.type)
} else if (this.keyword) {
this.doSearch()
} else if (this.searchKey) {
this.doPcSearch()
} else {
this.getCampaignGoods()
}
}
},
doLink(item, index) {
const length = this.bread.length;
if (index !== length) {
this.changePage(1)
if (index === 0) {
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {
cid: this.$route.query.cid,
}
})
} else if (index === 1) {
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {
cid: this.$route.query.cid,
type: item.id
}
})
}
}
}
},
}




// WEBPACK FOOTER //
// ./src/pages/home/Home.vue